import { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  LockKeyhole, 
  MessageCircleMore, 
  ArrowRight, 
  ArrowLeft, 
  Copy, 
  Check, 
  CreditCard 
} from 'lucide-react';
import { useI18n } from '../../contexts/I18nContext';
import { useStudentPortal } from '../../contexts/StudentPortalContext';
import ApplicationChat from '../../components/tracking/ApplicationChat';
import CountryFlag from '../../components/CountryFlag';

export default function PortalChat() {
  const { language, isRTL } = useI18n();
  const { workspace } = useStudentPortal();
  const [copied, setCopied] = useState(false);

  const application = workspace?.application;
  const unlocked = workspace?.capabilities.contact_consultant;
  const appId = application?.id || application?.application_number;
  const Arrow = isRTL ? ArrowLeft : ArrowRight;

  const handleCopyId = () => {
    if (!appId) return;
    navigator.clipboard?.writeText(String(appId));
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="portal-page">
      <div className="portal-page-heading" style={{ marginBottom: 18 }}>
        <div>
          <span className="portal-eyebrow">
            <MessageCircleMore size={15} />
            {language === 'ar' ? 'اتكلم معانا مباشره' : 'Direct Support'}
          </span>
          <h1>
            {language === 'ar' ? 'اتكلم معانا مباشره' : 'Consultant Chat'}
          </h1>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          {appId && (
            <button
              onClick={handleCopyId}
              className="portal-badge neutral"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                fontWeight: 800,
                cursor: 'pointer',
                border: '1px solid #e3dced',
                padding: '6px 12px',
                borderRadius: 9999,
                background: '#faf8fd'
              }}
              title={language === 'ar' ? 'نسخ رقم الطلب' : 'Copy Application ID'}
            >
              <span>#{appId}</span>
              {copied ? <Check size={13} color="#10b981" /> : <Copy size={13} style={{ opacity: 0.6 }} />}
            </button>
          )}

          {workspace?.country && (
            <span className="portal-badge" style={{ background: '#faf8fd', border: '1px solid #e5def0', padding: '6px 12px' }}>
              <CountryFlag code={workspace.country.code} fallback={workspace.country.flag} label={workspace.country.name} size="small" />
              <span>{workspace.country.name}</span>
            </span>
          )}

          <span className="portal-top-chat-status" style={{ padding: '6px 12px' }}>
            <span className="portal-live-ping" />
            {language === 'ar' ? 'متصل الآن' : 'Online'}
          </span>
        </div>
      </div>

      {!application || !unlocked ? (
        <div className="portal-card portal-empty" style={{ maxWidth: 600, margin: '48px auto', padding: '48px 32px' }}>
          <div className="portal-empty-icon" style={{ width: 68, height: 68, borderRadius: 24, marginBottom: 20 }}>
            <LockKeyhole size={30} />
          </div>
          <h3 style={{ fontSize: 20, fontWeight: 800, marginBottom: 10 }}>
            {language === 'ar' ? 'المحادثة تفتح بعد تأكيد الدفعة الأولى' : 'Chat opens after the initial payment is confirmed'}
          </h3>
          <p style={{ fontSize: 14, lineHeight: 1.6, marginBottom: 26, color: 'var(--portal-muted)' }}>
            {language === 'ar'
              ? 'يمكنك استكمال خطوات إعداد الطلب وتأكيد الدفعة الأولى لاعتماد مستشارك الأكاديمي وبدء التواصل المباشر.'
              : 'Complete your application setup and submit the initial payment to assign your counselor and start live messaging.'}
          </p>
          <Link to="/app/payments" className="portal-button portal-button-primary" style={{ padding: '0 28px' }}>
            <CreditCard size={18} />
            <span>{language === 'ar' ? 'الانتقال إلى المدفوعات' : 'Go to Payments'}</span>
            <Arrow size={16} />
          </Link>
        </div>
      ) : (
        <div className="portal-chat-shell">
          <ApplicationChat applicationId={application.id} isExpanded />
        </div>
      )}
    </div>
  );
}
